const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

/** "2026-09-16" or an ISO timestamp -> "16 Sep 2026". Date-only strings are not shifted by the timezone. */
export function formatDate(value: string, locale = "en-IN"): string {
  const date = DATE_ONLY.test(value) ? new Date(`${value}T00:00:00`) : new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(date);
}

/** Today (or an offset in days) as the yyyy-mm-dd an <input type="date"> wants. */
export function dateInputValue(daysFromToday = 0): string {
  const date = new Date();
  date.setDate(date.getDate() + daysFromToday);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
}
